export default __webpack_public_path__ + "static/media/meditation.eb2ec512.svg";